import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import SortDirection from 'owa-service/lib/contract/SortDirection';
import { SortColumn, TableView, getSelectedTableView, isFolderPaused } from 'owa-mail-list-store';
import { ActionSource } from 'owa-mail-store';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

export default {
    selectFilter: {
        name: 'TnS_SelectFilter',
        customData: (viewFilter: ViewFilter, actionSource: ActionSource) => {
            const tableView = getSelectedTableView();
            const isPaused = isFolderPaused(tableView.tableQuery.folderId);
            return [viewFilter, actionSource, isPaused];
        },
    },

    selectSort: {
        name: 'TnS_MailListSelectSort',
        customData: (
            sortColumn: SortColumn,
            sortDirection: SortDirection,
            tableView: TableView,
            actionSource: ActionSource
        ) => {
            const folderId = tableView.tableQuery.folderId;
            const isPaused = isFolderPaused(folderId);
            return [
                sortColumn,
                sortDirection,
                actionSource,
                tableView.totalRowsInView,
                folderIdToName(folderId),
                isPaused,
            ];
        },
    },
};
